import { motion } from 'framer-motion'
import { Code, Smartphone, Cloud, Edit } from 'react-feather'
import { Link } from 'react-router-dom'
import AnimatedBackground from '../common/AnimatedBackground'

import './Services.css'

export default function Services() {
  const services = [
    {
      icon: Code,
      title: "Web Development",
      description: "Custom web applications and responsive websites built with cutting-edge technologies.",
      link: "/services/web-development",
      features: ["React & Next.js", "Progressive Web Apps", "E-commerce Solutions", "API Development"]
    },
    {
      icon: Smartphone,
      title: "Mobile Development",
      description: "Native and cross-platform mobile applications for iOS and Android.",
      link: "/services/mobile-development",
      features: ["iOS & Android Apps", "React Native", "Flutter", "App Store Optimization"]
    },
    {
      icon: Cloud,
      title: "Cloud Solutions",
      description: "Scalable cloud infrastructure and DevOps services for modern businesses.",
      link: "/services/cloud-solutions",
      features: ["AWS & Azure", "Cloud Migration", "DevOps", "Serverless Architecture"]
    },
    {
      icon: Edit,
      title: "UI/UX Design",
      description: "User-centered design solutions that create engaging digital experiences.",
      link: "/services/ui-ux-design",
      features: ["User Research", "Wireframing", "Prototyping", "Design Systems"]
    }
  ]

  return (
    <section className="services-section">
      <AnimatedBackground text="" />
      <div className="services-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="services-header"
        >
          <h1>Our <span className="gradient-text">Services</span></h1>
          <p>Comprehensive digital solutions for your business needs</p>
        </motion.div>

        <div className="services-grid">
          {services.map((service, index) => {
            const Icon = service.icon
            return (
              <motion.div
                key={service.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: index * 0.2 }}
                className="service-card"
              >
                <div className="service-icon-wrapper">
                  <Icon size={32} />
                </div>
                <h2>{service.title}</h2>
                <p>{service.description}</p>
                <ul className="feature-list">
                  {service.features.map((feature, i) => (
                    <li key={i}>{feature}</li>
                  ))}
                </ul>
                <Link to={service.link} className="learn-more-button">
                  Learn More
                </Link>
              </motion.div>
            )
          })}
        </div>
      </div>
    </section>
  )
}